/*
 * Yurls Shop — carrousel.
 *
 * Gebruik:
 *   <yurls-carousel>
 *     <div data-track> ...kaarten... </div>
 *     <button data-prev>  <button data-next>
 *   </yurls-carousel>
 *
 * De pijlknoppen schuiven precies één kaart op. Zit je aan het begin of het
 * einde, dan wordt de betreffende knop uitgeschakeld — zo zie je meteen of er
 * nog meer is. Vegen met de vinger werkt gewoon, dat doet de browser zelf.
 */

if (!customElements.get('yurls-carousel')) {
  customElements.define(
    'yurls-carousel',
    class YurlsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');

        if (!this.track) return;

        this.onPrev = () => this.scrollByCard(-1);
        this.onNext = () => this.scrollByCard(1);
        this.onScroll = () => this.updateButtons();

        if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
        if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        // De breedte van een kaart verandert mee met het scherm.
        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this.track);

        this.updateButtons();
      }

      disconnectedCallback() {
        if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      /* Breedte van één kaart plus de tussenruimte. */
      get step() {
        const card = this.track.firstElementChild;
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      scrollByCard(direction) {
        this.track.scrollBy({ left: direction * this.step, behavior: 'smooth' });
      }

      updateButtons() {
        // Eenpixelmarge: browsers ronden scrollposities af, zonder marge zou de
        // knop aan het einde soms actief blijven.
        const margin = 1;
        const atStart = this.track.scrollLeft <= margin;
        const atEnd =
          this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - margin;

        if (this.prevButton) this.prevButton.disabled = atStart;
        if (this.nextButton) this.nextButton.disabled = atEnd;

        // Past alles binnen het beeld, dan zijn de knoppen overbodig.
        const overflows = this.track.scrollWidth > this.track.clientWidth + margin;
        this.toggleAttribute('data-no-overflow', !overflows);
      }
    }
  );
}
